<pos-app-spinner [show]="setIframeBaseUrlTimeout$ | async"></pos-app-spinner>
<div class="col">
  <div>
    <div class="card-container card">
      <div class="card-header" style="background-color: #e7e6e6">
        <div class="card-header-title">
          <h4 class="card-title text-uppercase"><label>Related sites</label></h4>
        </div>
      </div>

      <div class="d-flex justify-content-center position-relative">
        <div class="d-flex align-items-center scroll-arrow-left" *ngIf="showScrollArrows" (click)="scrollLeftb()">
          <mat-icon style="font-size: 40px; height: 40px; width: 40px">keyboard_arrow_left</mat-icon>
        </div>

        <div class="tile-grid-wrapper" #scrollContainer>
          <div
            class="tile-grid-container"
            [class.single-row-layout]="myHelpComponents?.length <= 6"
            [class.multi-row-layout]="myHelpComponents?.length > 6"
          >
            <div *ngFor="let myHelpComponent of myHelpComponents; let i = index" class="tile-wrapper">
              <div class="d-flex flex-column align-items-center">
                <div class="card card-sites" (click)="setIframeBaseUrl(myHelpComponent)">
                  <div *ngIf="!myHelpComponent.icon" class="logo-image"></div>
                  <div *ngIf="myHelpComponent.icon" class="logo-image" [ngStyle]="{ 'background-image': 'url(' + myHelpComponent.icon + ')' }"></div>
                </div>
                <div class="d-flex justify-content-center py-2 text-center tile-label">
                  <label style="white-space: nowrap">{{ myHelpComponent.label }}</label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="d-flex align-items-center scroll-arrow-right" *ngIf="showScrollArrows" (click)="scrollRightb()">
          <mat-icon style="font-size: 40px; height: 40px; width: 40px">keyboard_arrow_right</mat-icon>
        </div>
      </div>
    </div>
  </div>
</div>
